(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory7sService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory7s: function (parms) {
                return $ihttp.post({
                    method: 2696,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
